import _store from "store2";
import {checkUserIsAdmin, getPositionByLogin, logout} from "../../api/index";
import {V2UserInfoForToken} from "@/api/v2UserInfoForToken";
import {ElMessage} from "element-plus";
import {useWebSocket} from "../../Hooks";
import router from '@/router'
import store from "@/store";
import {getCompanyCurrentInfo} from "@/api/usercenter";
import sessionStore from "@/utils/sessionStore";
import {Storage} from "@/utils/storage";
import {UserTable} from "@/views/Marketing/db_user";
import {CustomerTable} from "@/views/Marketing/db_customer";

const userInfo = {
    account: "", accountType: 1, //1=个人账号 2=企业主账号 3=企业子账号
    enterpriseID: 0, guid: "", iM_Sign: "", photoUrl: "", token: "", userID: 0, userName: "", isVip: 0, userType: 10, //10 普通 20管路员 99主账号
};

const UserInfoForGUID = {
    guid: "",
    zoneCode: "",
    userCode: "",
    token: "",
    userID: 0,
    accountType: 1, //1=个人账号 2=企业主账号 3=企业子账号
    enterpriseID: 0,
    account: "",
    userName: "",
    phoneCode: "",
    phone: "",
    identificationStatus: 0,
    photoUrl: "",
    sex: 0,
    country: "",
    address: "",
    language: "",
    emailAddress: "",
    iM_Sign: "",
    teamID: 0,
    isVip: 0,
    vipExpireDate: null,
};

const token = _store.get("token");
const loginStatus = !!token || false;
const UserEmailList = _store.get("UserEmailList") || [];
const user = {
    namespaced: true, state: {
        loginStatus,
        userInfo: _store.get("userInfo") || userInfo,
        UserInfoForGUID: _store.get("UserInfoForGUID") || UserInfoForGUID,
        token,
        UserEmailList,
        userIsAdmin: sessionStore.get('userIsAdmin') ?? 1, //是否是管理员
        mailWorkPosition: {},//工位信息
        // 企业公司主账号信息
        companyInformation: {},
        tableDataEdm: [],
    }, getters: {
        isVipAccount(state) {
            // 会员等级:(0:免费用户,1:铜级用户,2:银级用户,3:金级用户)
            return typeof state.userInfo?.isVip === 'number' && state.userInfo.isVip > 0;
        },
        isVipUser(state) {
            const expireRaw = state.userInfo?.vipExpireDate;
            const expireTime = typeof expireRaw === 'string' ? new Date(expireRaw).getTime() : Number(expireRaw);
            const now = Date.now();

            console.log('VIP 过期时间:', expireTime);
            console.log('当前时间:', now);

            return expireTime > now || expireRaw === null && state.userInfo?.isVip * 1 !== 0;
        }, isEnterpriseChildUser(state) {
            return state.userInfo.accountType === 3;
        }, isEnterpriseMainUser(state) {
            return state.userInfo.accountType === 2;
        }, isNormalUser(state) {
            return state.userInfo.accountType === 1;
        }, //     超级管理员 superAdmin
        isSuperAdmin(state) {
            return state.userIsAdmin === 3
        }, //     管理员 admin
        isAdmin(state) {
            return state.userIsAdmin === 2
        }, //     普通用户
        isPublic(state) {
            return state.userIsAdmin === 1
        }
    }, mutations: {
        SetUserEmailList(state, list) {
            state.UserEmailList = list;
            _store("UserEmailList", list);
        }, setMailWorkPosition(state, payload) {
            state.mailWorkPosition = payload
        },
    }, actions: {
        async findTargetBuyType({dispatch}) {
            const raw = localStorage.getItem("selectTargetProduct");
            let selectTargetProduct;

            try {
                selectTargetProduct = JSON.parse(raw);
            } catch (e) {
                console.error("JSON 解析失败", e);
                return;
            }

            if (selectTargetProduct) {
                const {productSort} = selectTargetProduct;

                if (productSort && productSort >= 5) {
                    await dispatch("getUserInfoForGUID"); // user 模块内部调用
                } else if (productSort && productSort <= 4) {
                    await dispatch("cloud/queryByUserIdApis", null, {root: true}); // 跨模块调用
                }
            }

            console.log("selectTargetProduct", selectTargetProduct);
        }, UserLogin({state, commit}, userInfo) {
            Object.assign(state.userInfo, userInfo);
            state.token = userInfo.token;
            _store("userInfo", userInfo);
            _store("token", userInfo.token);
            // _store('imSign', userInfo.iM_Sign)
            _store("guid", userInfo.guid);
            _store("nBarUnreadMailNum", 0);
            commit("system/changeLanguage", userInfo.language, {root: true});
            state.loginStatus = true;
        }, async UserQuit({state, rootState, dispatch}) {
            try {
                await logout({userId: state.userInfo?.id})
                const {stopWS} = useWebSocket(state.userInfo.id);
                stopWS();
                window.socketTarget = null;
                state.token = "";
                state.UserEmailList = [];
                state.loginStatus = false;
                _store.remove("userInfo");
                _store.remove("UserInfoForGUID");
                Object.assign(state.userInfo, userInfo);
                Object.assign(state.UserInfoForGUID, UserInfoForGUID);
                _store.remove("token");
                _store.remove("imSign");
                _store.remove("guid");
                _store.remove("UserEmailList");
                _store("nBarUnreadMailNum", 0);
                // 过期退出
                localStorage.removeItem("currentTime");
                localStorage.removeItem("lastTime");
                // 清除其他模块
                let {email, system, cloud} = rootState;
                Object.assign(system.tabList[1], {
                    cacheName: "", query: {}, params: {},
                }); //重新登录后去除邮件缓存
                email.teamID = "";
                email.teamList = []; //重置团队列表
                email.teamListLoaded = false; //是否获取teamList重置
                email.EmailUnReadNum = 0; //重置邮件未读数
                email.RequestToAuditSum = 0;
                email.auditMailNum = 0;
                email.nBarUnreadMailNum = 0;
                email.mailFollowNum = 0;
                email.customerFollowNum = 0;
                system.friendList = []; //重置好友列表
                cloud.downloadStatus = "done";
                dispatch("email/resetTeam", {}, {root: true});
                system.isChatBoxVisibe = false; //关闭聊天
                // 清除所有数据
                localStorage.clear();
                Storage.clear()
                sessionStore.clear();
                // 清空数据表
                UserTable.clear()
                CustomerTable.clear()
                store.commit('email/setCurTeamID', '')
            } catch (e) {
                console.log(e, 'error')
            } finally {
                router.push('/login')
            }
        }, async getUserInfoForGUID({state, dispatch}) {
            const result = await V2UserInfoForToken();
            if (result.code !== 200) {
                dispatch("user/UserQuit")
                return
            }
            // 覆盖 userInfo 数据
            localStorage.setItem('userInfo', JSON.stringify(result.result))
            Storage.set("tinymce-default-font-family", result.result.userFront !== "" ? result.result.userFront : `"Microsoft YaHei", "Helvetica Neue", "PingFang SC", sans-serif`)
            state.userInfo = result.result
            const accountType = result.result.accountType;
            _store("UserInfoForGUID", accountType);
        }, // 判断当前用户是否是管理员
        async checkUserInfoIsAdmin({state}, payload) {
            let isUpdate = false
            if (payload) {
                isUpdate = payload.isUpdate
            }
            if (!sessionStore.get('userIsAdmin') || isUpdate) {
                try {
                    if (payload.teamId) {
                        let res = await checkUserIsAdmin(payload);
                        if (res.code !== 200) {
                            return;
                        }
                        state.userIsAdmin = res.result;
                        sessionStore.set("userIsAdmin", res.result)
                    }
                } catch (error) {
                    // console.log('[checkUserInfoIsAdmin]: error', error);
                }
            }
        }, //  获取工位
        async getPositionByLoginList({state, commit}) {
            const res = await getPositionByLogin();
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return;
            }
            state.mailWorkPosition = res.result
        },

        //     获取企业相关的全部数据
        async getCompanyCurrentInfoApis({state}, commit) {
            const res = await getCompanyCurrentInfo()
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return;
            }
            state.companyInformation = res.result
        },

    },
};

export default user;
